import type { TFunction } from 'i18next'
import orderBy from 'lodash/orderBy'

import type { RelatedDocument } from '@features/invoices/types/relatedDocument'
import type { RelatedInvoice } from '@features/invoices/types/relatedInvoice'
import { getRelatedDocumentFromRelatedInvoice } from '@features/invoices/utils/depositInvoices/getRelatedDocumentFromRelatedInvoice'

export const getQuoteRelatedInvoices = (
  relatedInvoices: RelatedInvoice[] | undefined,
  t: TFunction,
): RelatedDocument[] =>
  orderBy(relatedInvoices, [(invoice) => invoice.invoiceId ?? invoice.invoiceDraftId], ['desc']).map((invoice) =>
    getRelatedDocumentFromRelatedInvoice(invoice, t),
  )
